import type { Tone } from "@nabble/ui";

export type UserStatus = "INVITED" | "ACTIVE" | "LOCKED" | "DISABLED";

export const STATUS_LABEL: Record<UserStatus, string> = {
  INVITED: "Invited",
  ACTIVE: "Active",
  LOCKED: "Locked",
  DISABLED: "Disabled",
};

export const STATUS_TONE: Record<UserStatus, Tone> = {
  INVITED: "info",
  ACTIVE: "success",
  LOCKED: "warning",
  DISABLED: "neutral",
};
